{
  "header": "Skogeier",
  "contractorHeader": "Entreprenør",
  "timberBuyerHeader": "Tømmerkjøper",
  "entitySelectorLabel": "Hva vil du søke etter?",
  "entitySelectorPlaceholder": "Velg type",
  "entitySelectorOptionSkogeier": "Skogeier",
  "entitySelectorOptionEiendom": "Eiendom",
  "entitySelectorOptionEntreprenor": "Entreprenør",
  "entitySelectorOptionTommerkjoper": "Tømmerkjøper",
  "searchLabel": "Søk etter navn, kundenummer, epost eller telefonnummer",
  "registerButton": "Registrer skogeier",
  "propertySearchPanel": {
    "municipalityRequired": "Kommune er påkrevd",
    "municipalityLabel": "Kommune eller kommunenummer",
    "gardsnummerLabel": "Gårdsnummer (valgfritt)",
    "bruksnummerLabel": "Bruksnummer (valgfritt)",
    "advancedSearchToggle": "Flere søkevalg",
    "advancedSearchLabel": "Finn eiendommer tilknyttet navn eller leverandørnummer",
    "searchButton": "Søk",
    "loadingMessage": "Laster eiendommer...",
    "emptyMessage": "Ingen eiendommer funnet.",
    "legalOwnerHeader": "Juridisk eier",
    "noLegalOwner": "Ingen eier registrert"
  },
  "searchButton": "Søk"
}
